import { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import { db, firebaseConfigured } from './firebase'
import type { Project } from './types'

export function usePublishedProjects() {
  const [projects, setProjects] = useState<Project[]>([])
  const [loading, setLoading] = useState(firebaseConfigured)
  useEffect(() => {
    if (!firebaseConfigured) return
    const q = query(collection(db, 'projects'), where('status', '==', 'published'), orderBy('displayOrder'), orderBy('createdAt', 'desc'))
    return onSnapshot(q, (snap) => { setProjects(snap.docs.map((d) => ({ id: d.id, ...d.data() } as Project))); setLoading(false) }, () => setLoading(false))
  }, [])
  return { projects, loading }
}
